import React, { FC } from 'react'
import { Route, Switch } from 'react-router-dom'

import { routes } from '../../constants/routes'
import { Companies } from './Companies'
import { CreateCompany } from './CreateCompany'
import { CompanyProfileTabs } from '../CompanyProfile/CompanyProfileTabs'

export const CompaniesRoutes: FC = () => {
  return (
    <Switch>
      <Route path={routes.COMPANIES} exact component={Companies} />
      <Route path={routes.COMPANY_CREATE} component={CreateCompany} />
      <Route path={routes.COMPANY_DETAILS_TABS} component={CompanyProfileTabs} />
    </Switch>
  )
}
